import { UcoastEl } from '@/scripts/core/UcoastEl'
import { getBackendRoute, getOrThrow, qsOptional, qsRequired } from '@/scripts/core/global'
import {KlaviyoOosPopup} from "@/scripts/theme/klaviyo-oos-popup";
type AddToWaitlistConfigInput = {
	email: string;
	variant_id: string;
}
export class KlaviyoOosForm extends UcoastEl {
	static htmlSelector = 'klaviyo-oos-form'
	form: HTMLFormElement
	submitButton: HTMLButtonElement
	emailInput: HTMLInputElement
	successEl: HTMLElement
	route: string
	popup?: KlaviyoOosPopup
	variant?: string
	constructor() {
		super()
		this.form = qsRequired('form', this)
		this.submitButton = qsRequired('[type="submit"]', this)
		this.emailInput = qsRequired('[type="email"]', this)
		this.successEl = qsRequired('[data-uc-form-status]', this)
		this.route = `${getBackendRoute()}/api/klaviyo-oos`
		this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
		this.popup = qsOptional<KlaviyoOosPopup>('notify-me', this)
	}

	onSubmitHandler(event: Event) {
		event.preventDefault()
		if (this.submitButton.getAttribute('aria-disabled') === 'true') return
		if (this.emailInput.value.length < 1) return

		this.submitButton.setAttribute('aria-disabled', 'true')
		this.submitButton.classList.add('loading')

		const formData = new FormData(this.form)
		const data: AddToWaitlistConfigInput = {
			email: getOrThrow(formData, 'email'),
			variant_id: getOrThrow(formData, 'variant'),
		}
		const config = this.addToWaitlistConfig(data)

		fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=QKsbap`, config)
			.then((response) => response.text())
			.then((_) => {
				this.emailInput.value = ''
				this.successEl.classList.remove('hidden')
				this.submitButton.classList.add('success')
				this.emailInput.placeholder = 'Thanks for signing up'
				if (this.popup) {
					window.setTimeout(() => {
						this.popup?.hide()
					}, 5000)
				}
			})
			.catch((e) => {
				this.emailInput.placeholder = 'This email address is invalid.'
				console.error(e)
			})
			.finally(() => {
				this.submitButton.classList.remove('loading')
				this.submitButton.removeAttribute('aria-disabled')
			})
	}


	addToWaitlistConfig({email, variant_id}: AddToWaitlistConfigInput) {
		return {
			method: 'POST',
			headers: {
				accept: 'application/json',
				Revision: '2024-05-15',
				'content-type': 'application/json',
			},
			body: JSON.stringify({
				data: {
					type: 'back-in-stock-subscription',
					attributes: {
						channels: ['EMAIL'],
						profile: {
							data: {
								type: 'profile',
								attributes: {
									email: email
								},
							},
						},
					},
					relationships: {
						variant: {
							data: {
								type: 'catalog-variant',
								id: `$shopify:::$default:::${variant_id}`,
							},
						},
					},
				},
			}),
		}
	}
}
